export function isOpenInNewTabClick({
  ctrlKey,
  metaKey,
  shiftKey
}: Pick<MouseEvent, 'ctrlKey' | 'metaKey' | 'shiftKey'>): boolean {
  return ctrlKey || metaKey || shiftKey;
}

export function isMiddleClick({ button }: Pick<MouseEvent, 'button'>): boolean {
  return button === 1;
}
